import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';

export const commonService = {
  countries: () => axios.get(Pathes.Common.countries),
};
